define('OutSystems/ClientRuntime/TransitionAnimation',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TransitionAnimation = void 0;
    var TransitionAnimation;
    (function (TransitionAnimation) {
        TransitionAnimation[TransitionAnimation["None"] = 0] = "None";
        TransitionAnimation[TransitionAnimation["Default"] = 1] = "Default";
        TransitionAnimation[TransitionAnimation["Fade"] = 2] = "Fade";
        TransitionAnimation[TransitionAnimation["SlideFromLeft"] = 3] = "SlideFromLeft";
        TransitionAnimation[TransitionAnimation["SlideFromRight"] = 4] = "SlideFromRight";
        TransitionAnimation[TransitionAnimation["SlideFromBottom"] = 5] = "SlideFromBottom";
        TransitionAnimation[TransitionAnimation["SlideFromTop"] = 6] = "SlideFromTop";
    })(TransitionAnimation || (exports.TransitionAnimation = TransitionAnimation = {}));
});
//# sourceMappingURL=TransitionAnimation.js.map;
